<script lang="ts" setup>
import DisputeResolutionTemplate from '~/components/templates/DisputeResolutionTemplate/DisputeResolutionTemplate.vue';

useAppMeta({
  title: '当社の苦情処理・紛争解決に係る体制について',
});
</script>

<template>
  <DisputeResolutionTemplate />
</template>
